<template>
	<div class="wrap" @click.stop="" @touchstart.stop="">
		<button class="btn btn-default w select-popper-btn"
			:class="{active : isActive}"
			:disabled="disabled"
			@click="toggle">
				{{selectedName || placeholder}} <i class="fa fa-caret-down" ></i>
				<!-- <i class="closei fa fa-window-close" v-show="isActive && isClear" @click="clearSel"></i> -->
		</button>
		<div class="cont select-popper" :style="{maxHeight: (maxHeight || 300) + 'px'}" :class="{active : isActive}" :id="id">
			<ul class="beautyul">
				<li v-if="multiple && soptions.length">
					<div class="btn-group btn-block mb10">
						<button type="button" class="btn btn-default select-btn" @click="selectAll">全选</button>
						<button type="button" class="btn btn-default select-btn" @click="cancelAll">取消</button>
					</div>
					<!-- <input type="text" class="form-control mt10"> -->
				</li>
				<li v-for="(o,index) in soptions" @click="selHandle(o,index)" :class="{active:o.$isActive}">
					<p>{{o[name]}}</p> <i class="fa"></i>
				</li>
				<li v-show="!soptions.length" class="text-center">
					暂无数据
				</li>
			</ul>
		</div>
		<!--
		<select>
			<option value="o.value" v-for="o in sconfig.options">{{o.name}}</option>
		</select> -->
	</div>
</template>
<script>
	import { createPopper } from '@popperjs/core';
	export default {
		name : 'kxSelectPopper',
		props : {
			'options' : {required : true,type : Array},
			'multiple' : {type : Boolean,default : false},
			'beautyName' : {type : String},
			'name' : {default : 'name',type : String},
			'valueName' : {default : 'value',type : String},
			'change' : {default : Function,type : Function},
			'isClear' : {type : Boolean,default : false},
			value : {},
			maxHeight : {type : Number,default : 300},
			placeholder : String,
			canCancel : {type : Boolean, default : true},
			defaultSelect : Boolean,
			disabled : Boolean,
		},
		destroyed (){
			if(this.popperInstance){
				this.popperInstance.destroy();
			}
			this.$kxSelectPopper.remove(this);
		},
		mounted (){
			this.$kxSelectPopper.add(this);
			this.soptions = this.Helper.clone(this.options,true);
			this.defaultSelectDo();
			this.popperInstance = createPopper(this.$el.querySelector('.select-popper-btn'), this.$el.querySelector('.select-popper'), {
				placement : 'bottom-start',
				strategy : 'fixed',
			});
		},
		data (){
			return {
				isActive : false,
				soptions : [],
				id : 'kxSelect_beauty_ul_'+this._uid,
				popperInstance : null,
			}
		},
		methods : {
			close (){
				this.isActive = false;
			},
			toggle (e){
				e && e.preventDefault();
				this.isActive = !this.isActive;
				if(this.isActive){
					let selectDom = document.getElementById(this.id);
					this.$nextTick(()=>{
						let {left} = this.Helper.getOffset(selectDom);
						let leftMain = document.getElementById('leftMain');
						if(left + selectDom.offsetWidth > leftMain.offsetWidth){
							selectDom.classList.add('right');
						}else{
							selectDom.classList.remove('right');
						}
					})
				}
			},
			selHandle (option,index){
				this.setActive([index]);
				this.$emit('change')
			},
			setActive (sindexArr,notNeedChange=false){
				if(this.multiple){
					for(let index of sindexArr.keys()){
						let i = sindexArr[index];
						this.$set(this.soptions[i],"$isActive",!this.soptions[i].$isActive);
						if(!this.soptions[i].$isActive){
							this.$emit('removeTag');
						}
					}
				}else{
					for(let [i,v] of this.soptions.entries()){
						// let isactive = sindexArr.includes(index) &&
						// 				this.soptions[sindexArr[0]][this.valueName] !== undefined;
						// console.log(isactive);
						// this.$set(v,"$isActive",!isactive);
						// console.log(i,v)
						if(i === sindexArr[0] && sindexArr.includes(i) &&
										this.soptions[sindexArr[0]][this.valueName] !== undefined){
							this.$set(v,"$isActive", this.canCancel ? !v.$isActive : true);
						}else{
							this.$set(v,"$isActive",false);
						}

					}
					this.toggle();
				}
				if(!notNeedChange){
					this.$emit('input',this.soptions.filter(v=>v.$isActive));
				}
			},
			selectAll (){
				for(let [,v] of this.soptions.entries()){
					this.$set(v,"$isActive",true);
				}
				this.$emit('input',this.soptions.filter(v=>v.$isActive));
				this.$emit('change')
			},
			cancelAll (){
				for(let [,v] of this.soptions.entries()){
					this.$set(v,"$isActive",false);
				}
				this.$emit('input',this.soptions.filter(v=>v.$isActive));
				this.$emit('change')
			},
			clearSel (){
				for(let [,v] of this.soptions.entries()){
					this.$set(v,"$isActive",false);
				}
				this.$emit('input',this.soptions.filter(v=>v.$isActive));
				this.$emit('change')
			},
			defaultSelectDo () {
				if(this.defaultSelect && this.soptions[0]){
					if(!Array.isArray(this.value)) {
						this.$set(this.soptions[0],'$isActive',true);
					} else {
						this.soptions.map((option)=>{
							if(Array.isArray(this.value)){
								this.value.map((v)=>{
									if(v[this.valueName] === option[this.valueName]){
										this.$set(option,'$isActive',true);
									}
								})
							}
						})
					}
					this.$emit('input',this.soptions.filter(v=>v.$isActive));
					this.$emit('defaultSelectChange');
				}
			},
		},
		watch : {
			isActive (newval){
				if(newval){
					this.$kxSelectPopper.closeOthers(this);
				}
			},
			options (){
				this.soptions = this.Helper.clone(this.options,true);
				this.defaultSelectDo();
			},
			selected (){
				// this.$emit('change')
			},
			value (){
				// let index = [];
				this.soptions.map((option)=>{
					this.$set(option,'$isActive',false);
					if(Array.isArray(this.value)){
						this.value.map((v)=>{
							if(v[this.valueName] === option[this.valueName]){
								// index.push(i);
								this.$set(option,'$isActive',true);
							}
						})
					}else{
						try{
							if(this.value[this.valueName] === option[this.valueName]){
								// index.push(i)
								this.$set(option,'$isActive',true);
							}
						}catch(e){

						}
					}
				})
				// this.setActive(index,true);
			}
		},
		computed : {
			selected (){
				if(this.multiple){
					let active = [];
					for(let [,v] of this.soptions.entries()){
						if(v.$isActive){
							active.push(v);
						}
					}
					return active;
				}else{
					let active = null;
					for(let [,v] of this.soptions.entries()){
						if(v.$isActive){
							active = v;
							break;
						}
					}
					// if(!active){
					// 	active = this.soptions[0];
					// }
					return active;
				}
			},
			selectedName (){
				if(Array.isArray(this.selected)){
					let name = [];
					for(let [,s] of this.selected.entries()){
						name.push(s[this.name]);
					}
					return name.join(',') || this.beautyName;
				}else{
					return this.selected ? this.selected[this.name] : this.beautyName;
				}
			}
		}
	}
</script>
<style scoped>
	.wrap{position: relative;padding-right: 5px;}
	.btn{padding: .05rem .23rem .05rem .17rem;max-width: 200px;overflow: hidden;word-break: break-all;white-space: nowrap;text-overflow: ellipsis;position: relative;width: 100%;cursor: pointer;}
	.btn.active{box-shadow: inset 0 3px 5px #e3e3e3;}
	.btn i{width: .2rem;transition: all 200ms;display: inline-block;position: absolute;right: 5px;top: 5px;}
	.btn .closei{position: static;}
	.btn.active i{transform: rotate(180deg)}
	.cont{
		position: absolute;
	    top: 100%;
	    left: 0;
	    z-index: 1000;
	    display: none;
	    float: left;
	    min-width: 108px;
	    padding: 5px;
	    margin: 2px 0 0;
	    font-size: 14px;
	    text-align: left;
	    list-style: none;
	    background-color: #fff;
	    -webkit-background-clip: padding-box;
	    background-clip: padding-box;
	    border: 1px solid #ccc;
	    border: 1px solid rgba(0,0,0,.15);
	    border-radius: 4px;
	    -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
	    box-shadow: 0 6px 12px rgba(0,0,0,.175);
	    max-height: 300px;
		overflow: auto
	}
	.cont.active{display: block;}
	.cont.right{left: auto;right: 0;}
	.beautyul li{line-height: .35rem;height: .35rem;overflow: hidden;cursor: pointer;}
	.beautyul li p{white-space: nowrap;}
	.beautyul li.active{position: relative;padding-right: 20px;}
	.beautyul li.active i:before{content: "\f00c";}
	.beautyul li.active i{position: absolute;right: 0;top: .08rem;}
	.select-btn{padding-left: 0;padding-right: 0;overflow: unset;}
</style>



// WEBPACK FOOTER //
// kxSelect.vue?3d775368